<template>
  <img
    :src="show ? Eye : EyeSlash"
    :class="`show-password ${show ? 'eye': 'eye-slash'}`"
    @click="clickIcon">
</template>
<script>
import Eye from '../assets/images/revealpw.svg';
import EyeSlash from '../assets/images/hidepw.svg';

export default {
  name: 'ShowPassword',
  data() {
    return {
      show: false,
      Eye,
      EyeSlash,
    };
  },
  methods: {
    clickIcon() {
      this.show = !this.show;
      this.$emit('show', this.show);
    },
  },
};
</script>
<style lang="scss" scoped>
.show-password {
  position: absolute;
  padding: 0 5px;
  right: 0px;
  top: 45px;
  &.eye-slash {
    top: 42px;
  }
}
</style>



// WEBPACK FOOTER //
// app/src/components/ShowPassword.vue